<template>
  <div>
    <TableFilters
      :filters="['product', 'warehouse', 'dateRange']"
      v-model="filter"
      :columns="columns"
      @updateColumnsTable="updateColumnsTable"
      :export="[`purchaseorderexport`]"
    ></TableFilters>
    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="pdfdownload()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-card class="lighten-12 mt-2" v-show="false">
      <v-container fluid class="light gray lighten-12">
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="PurchaseOrderList"
              class="row-pointer"
              item-key="id"
              id="indextable3"
            >
              <template v-slot:no-data>
                <div class="mt-16 container justify-center item-center">
                  <noData name="Purchase" />
                </div>
              </template>

              <template v-slot:top>
                <tr>
                  <th>Product Name:</th>
                  <th>{{ filterDatas.productquery }}</th>
                  <th></th>
                  <th>Warehouse Name:</th>
                  <th>{{ filterDatas.warehousequery }}</th>
                </tr>
              </template>

              <template v-slot:item.quantity="{ item }">{{
                item.quantity ? item.quantity : '.........'
              }}</template>

              <template v-slot:item.date="{ item }">{{
                item.purchaseOrder.date | formatDate
              }}</template>

              <template v-slot:item.warehouse="{ item }">{{
                item.purchaseOrder.wareHouse.name
                  ? item.purchaseOrder.wareHouse.name
                  : '.........'
              }}</template>

              <template v-slot:item.supplier="{ item }">{{
                item.purchaseOrder.supplier.name
                  ? item.purchaseOrder.supplier.name
                  : '.........'
              }}</template>
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import _ from 'lodash';
import noData from '@/components/shared/noItem';
import { mapState } from 'vuex';

export default {
  // mixins: [Suppliers],
  data: () => ({
    hide: '',
    purchaseOrderStatus: ['Pending', 'Canceled', 'Received'],
    messages: [],
    errors: [],
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],
    columns: [
      {
        text: 'No',
        value: 'no',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.no,
      },
      {
        text: 'Purchase Order Date',
        value: 'date',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => moment(item?.purchaseOrder.date).format('YYYY-MM-DD'),
      },

      {
        text: 'Warehouse',
        value: 'warehouse',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.purchaseOrder.wareHouse.name,
      },

      {
        text: 'Supplier',
        value: 'supplier',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.purchaseOrder.supplier.name,
      },
      {
        text: 'Quantity',
        value: 'quantity',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.quantity,
      },
    ],
    // For Purchase Order Table Data
    PurchaseOrderList: [],

    //For Filter
    date_range: [],
    filter: {
      invoice_status: '',
      start: '',
      end: '',
      amount: '',
      supplier: '',
      search: '',
      status: '',
    },
    menu: false,
  }),
  components: {
    TableFilters,
    noData,
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },
  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },
  computed: {
    ...mapState(['WarehouseView']),
    ...mapState(['filterDatas']),

    dateRangeText() {
      this.filter.start = this.date_range[0];
      this.filter.end = this.date_range[1];
      return this.date_range.join(' ~ ');
    },
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    dateFormat: function (date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    generateReport(callBack = () => {}) {
      if (this.filter.warehouse && this.filter.product) {
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
        var filter = this.filter;
        this.$store
          .dispatch('report/getPurchaseOrderReportProductManagement', filter)
          .then((res) => {
            if (res.data.data.length === 0) {
              this.PurchaseOrderList = [];
            } else {
              let i = 1;
              this.PurchaseOrderList = res.data.data[0].purchaseOrderItems;
              this.PurchaseOrderList.map((p) => {
                p.no = i;
                i++;
              });
            }

            setTimeout(() => {
              // Update Pdf To List
              callBack();
              this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
              this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
              // Update Pdf To List Datas
              this.$store.commit('UPDATE_PDF_DATAS', this.PurchaseOrderList);
              // Update Pdf To List_Title
              this.$store.commit(
                'UPDATE_PDF_TITLE',
                'Purchase Order Report Product Management',
              );
            }, 100);
          })

          .catch((err) => {
            this.isLoading = false;
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            this.$store.commit('UPDATE_PDF_VISIBLE', false);
            this.messages = err.data.title;
          });
      } else if (this.filter.warehouse) {
        this.$confirm('Please Select the Product then Try?');
      } else if (this.filter.product) {
        this.$confirm('Please Select the Warehouse then Try?');
      } else {
        this.$confirm('Please Select the Warehouse and Product then Try?');
      }
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.PurchaseOrderList.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 400);
    },
    //Product Details Export Pdf
    async pdfdownload() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.PurchaseOrderList);
        for (let x = 0; x < Data.length; x++) {
          Data[x].quantity = Data[x].quantity;
          Data[x].date = moment(
            Data[x].purchaseOrder.date,
            'YYYY-MM-DD',
          ).format('DD/MM/YYYY');

          Data[x].warehouse = Data[x].purchaseOrder.wareHouse.name;
          Data[x].supplier = Data[x].purchaseOrder.supplier.name;
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });

        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'normal');
        doc.text('Purchase Order Report Product Management', 14, 6);

        doc.setFontSize(8);
        doc.text(
          250,
          6,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );

        // doc.text(160, 10, `Product:-${this.filterDatas.productquery}`);
        // doc.text(210, 10, `Warehouse:-${this.filterDatas.warehousequery}`);

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-Purchase Order.pdf`);
      };
      this.generateReport(printPdf);
    },

    //Product Details Export Excel
    async exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable3');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-Purchase Order.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
    getPurchaseOrderStatusColor(status) {
      switch (status) {
        case 'Received':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;
        default:
          break;
      }
    },
  },
};
</script>
